import { Input, Label } from '@/components/ui';

interface Props {
  value: string;
  onChange: (next: string) => void;
  error?: string | null;
}

// Plain email field — Pay.com handles verification on its side; we just
// capture the address. Marked `inputMode="email"` for mobile keyboards
// and `autoComplete="email"` so password managers can fill.
export function SkrillEmailField({ value, onChange, error }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="skrill-email">Skrill account email</Label>
      <Input
        id="skrill-email"
        type="email"
        inputMode="email"
        autoComplete="email"
        placeholder="you@example.com"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={!!error}
      />
      {error ? (
        <p className="text-xs text-danger-alt">{error}</p>
      ) : (
        <p className="text-xs text-muted">Pay.com sends funds to this Skrill account. Must match the name on file.</p>
      )}
    </div>
  );
}
